module.exports = __webpack_public_path__ + "static/media/ic_robotrader_about_one.484e57af.svg";